import { taskCount } from "@/lib/plural";

interface Props {
  count: number;
  revealed: boolean;
  onToggle: () => void;
}

export default function HiddenTasksToggle({ count, revealed, onToggle }: Props) {
  if (count === 0) return null;

  return (
    <button
      type="button"
      onClick={onToggle}
      data-testid="hidden-tasks-toggle"
      className="self-start mt-3 text-xs text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 cursor-pointer"
    >
      {revealed ? "Спрятать отложенные на потом" : `Позже сегодня: ${taskCount(count)}`}
    </button>
  );
}
